import { render } from "./ModalEditarPrograma.vue?vue&type=template&id=0cf58f4c"
import script from "./ModalEditarPrograma.vue?vue&type=script&lang=js"
export * from "./ModalEditarPrograma.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__